import { BasicCartesianChartConfig } from '@app/data/interface/widget-config';

import { configureChart, generateSeries } from '@app/widgets/helpers/widget-helpers';

export const WaiFieldWaterSamplingPakipaki: BasicCartesianChartConfig = configureChart(
  'WAI - Field Water Sampling: Pakipaki',
  generateSeries(
    ['boprc_kaituna_at_te_matai'],
    ['water-temperature', 'ph-in-lab', 'turbidity', 'setchi-disk', 'dissolved-oxygen-mg-per-litre']
  )
);

export const WhakaaweWhenuaMaungarangiRd: BasicCartesianChartConfig = configureChart(
  'WHAKAAWE WHENUA - Land Use Impact: Maungarangi Rd',
  generateSeries(
    ['boprc_kaituna_at_maungarangi_rd'],
    ['total-phosphorus', 'total-kjeldahl-nitrogen', 'water-temperature']
  )
);

export const PanoniMaungarangiRd: BasicCartesianChartConfig = configureChart(
  'PANONI - Land Use Change Over Time: Maungarangi Rd',
  generateSeries(
    ['boprc_kaituna_at_maungarangi_rd'],
    ['dissolved-oxygen-mg-per-litre', 'turbidity', 'water-temperature']
  )
);

export const WaiFieldWaterSamplingMaungarangiRd: BasicCartesianChartConfig = configureChart(
  'WAI - Field Water Sampling: Maungarangi Rd',
  generateSeries(
    ['boprc_kaituna_at_maungarangi_rd'],
    ['ph-in-lab', 'water-temperature', 'turbidity', 'setchi-disk', 'dissolved-oxygen-mg-per-litre', 'flow']
  )
);

export const WaiRaparapa: BasicCartesianChartConfig = configureChart(
  'WAI - Field Water Sampling: Ohineangaanga/Te Raparapaahoe',
  generateSeries(['boprc_kaituna_at_clarkes'], ['ph-in-lab', 'water-temperature', 'turbidity'])
);

export const TaiaoRaparapa: BasicCartesianChartConfig = configureChart(
  'TAIAO - Ecosystem Health: Ohineangaanga/Te Raparapaahoe',
  generateSeries(
    ['boprc_kaituna_at_clarkes'],
    ['e.-coli', 'water-temperature', 'total-kjeldahl-nitrogen', 'dissolved-reactive-phosphorous']
  )
);

export const WhakaaweWhenuaPakiPaki: BasicCartesianChartConfig = configureChart(
  'WHAKAAWE WHENUA - Land Use Impact: Pakipaki',
  generateSeries(['boprc_kaituna_at_te_matai'], ['total-phosphorus', 'total-kjeldahl-nitrogen', 'water-temperature'])
);

export const PanoniPakipaki: BasicCartesianChartConfig = configureChart(
  'PANONI - Land Use Change Over Time: Pakipaki',
  generateSeries(
    ['boprc_kaituna_at_te_matai'],
    ['dissolved-oxygen-mg-per-litre', 'turbidity', 'water-temperature', 'precipitation']
  )
);

export const WhakaaweWhenuaKaitunaDiversion: BasicCartesianChartConfig = configureChart(
  'WHAKAAWE WHENUA - Land Use Impact: Kaituna diversion',
  generateSeries(
    ['boprc_maketu_estuary_at_boat_ramp'],
    ['total-phosphorus', 'total-kjeldahl-nitrogen', 'water-temperature']
  )
);

export const PanoniKaitunaDiversion: BasicCartesianChartConfig = configureChart(
  'PANONI - Land Use Change Over Time: Kaituna diversion',
  generateSeries(
    ['boprc_maketu_estuary_at_boat_ramp'],
    ['dissolved-oxygen-mg-per-litre', 'turbidity', 'water-temperature']
  )
);

export const WaiFieldWaterSamplingKaitunaDiversion: BasicCartesianChartConfig = configureChart(
  'WAI - Field Water Sampling: Kaituna diversion',
  generateSeries(
    ['boprc_maketu_estuary_at_boat_ramp'],
    ['water-temperature', 'ph-in-lab', 'turbidity', 'setchi-disk', 'dissolved-oxygen-mg-per-litre']
  )
);

export const WaiParaitiStraight: BasicCartesianChartConfig = configureChart(
  'WAI - Field Water Sampling : Paraiti straight',
  generateSeries(['boprc_paraiti_at_maungarangi_rd'], ['relative-water-level'])
);
